import { postCoreDataSecurityAccessLogExportSlice } from './post';

export const { requestPostCoreDataSecurityAccessLogExport, resetPostCoreDataSecurityAccessLogExport } =
	postCoreDataSecurityAccessLogExportSlice.asyncActionCreators;
